import(/* webpackMode: "eager", webpackExports: ["IndividualsPageView"] */ "/home/runner/work/multi-domain-website-framework/multi-domain-website-framework/apps/nippon-center-pakistan/src/components/audience/IndividualsPageView.tsx");
